// import localStorage from 'local-storage'
import { ROUTES } from '../constant'
import { initApolloClient } from '../lib/apollo'
import { SIGN_OUT } from '../mutations/sign_out'
import { LOCAL_STORAGE_KEY, REFERRER_CODE } from './constant'
import { getConfig } from "~/utils/index";

export function updateUser({ user, access_token: token }) {
  localStorage.setItem(LOCAL_STORAGE_KEY.TOKEN, token)
  localStorage.setItem(LOCAL_STORAGE_KEY.AUTH, JSON.stringify(user))

  const OneSignal = window.OneSignal || []
  OneSignal.push(function () {
    OneSignal.setExternalUserId(user.id)
  })
}

export const signOut = async ({ withSignOutMutation } = {}) => {
  if (!process.browser) return
  if (withSignOutMutation) {
    const client = initApolloClient()
    const OneSignal = window.OneSignal || []
    let oneSignalUserId = null
    if (getConfig('ENV') !== 'local' && (OneSignal.length > 0 || Object.keys(OneSignal).length > 0)) {
      await OneSignal.isPushNotificationsEnabled().then(async function(isEnabled) {
        if (isEnabled)
          oneSignalUserId = await OneSignal.getUserId()
        else
          console.log("LogOut: Push notifications are not enabled yet.");
      });
    }
    try {
      await client.mutate({
        mutation: SIGN_OUT,
        variables: { oneSignalUserId },
      })
    } catch (error) {
      console.error(error.message)
    }
  }
  if (localStorage.getItem(LOCAL_STORAGE_KEY.AUTH) || localStorage.getItem(LOCAL_STORAGE_KEY.TOKEN)) {
    localStorage.removeItem(LOCAL_STORAGE_KEY.AUTH)
    localStorage.removeItem(LOCAL_STORAGE_KEY.TOKEN)
    localStorage.removeItem(REFERRER_CODE)
    localStorage.clear()
    window.location.href = ROUTES.LOGIN
  }
}

export default signOut
